import Vue from 'vue'
import dialog from './dialog.vue'

const DialogConstructor = Vue.extend(dialog)

let instance

const msg = function(content = '', options = {}, type = '') {
  options = {
    content,
    ...options,
    type
  }
  instance = new DialogConstructor({
    propsData: options
  })

  instance.vm = instance.$mount()

  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.visible = true
  })
}
const Confirm = (content, options = {}) => {
  msg(content, options)
}

const Alert = (content, options = {}) => {
  msg(content, options, 'alert')
}

export {
  Confirm,
  Alert
}
